import { Alert } from './alert-class';
import { FilesClass } from './uploads-class';
import { Image } from './common-class';
import dayjs from 'dayjs';

export class CustomerRedFlagTypeClass {
  idCustomerRedFlagType: number | null = null;
  Code: string = '';
  Description: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  Order: number | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';

  public parseDates() {
    const dateFields = ['DateStart', 'DateEnd'];
    dateFields.forEach(f => {
      if (this[f] && (typeof this[f] === 'string' || this[f] instanceof Date)) {
        const val = this[f];
        let d = dayjs.utc(val);
        if (!d.isValid() && typeof val === 'string') {
          const formats = ['DDMMYYYY', 'DD-MM-YYYY', 'DD-MM-YYYY'];
          for (const format of formats) {
            const dManual = dayjs.utc(val, format, true);
            if (dManual.isValid()) {
              d = dManual;
              break;
            }
          }
        }
        if (d.isValid()) {
          this[f] = d.startOf('day').toDate();
        }
      }
    });
  }
}

export class CustomerRedFlagClass {
  idCustomerRedFlag: number | null = null;
  idCustomer: number | null = null;
  idCustomerRedFlagType: number | null = null;
  idIntermediary: number | null = null;
  RecordDate: Date | null = null;
  Notes: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';
  // Campos extras devolvidos pela SP
  TypeDescription?: string;
  MediatorName?: string;

  public parseDates() {
    const dateFields = ['RecordDate', 'DateStart', 'DateEnd'];
    dateFields.forEach(f => {
      if (this[f] && (typeof this[f] === 'string' || this[f] instanceof Date)) {
        const val = this[f];
        let d = dayjs.utc(val);
        if (!d.isValid() && typeof val === 'string') {
          const formats = ['DDMMYYYY', 'DD-MM-YYYY', 'DD-MM-YYYY'];
          for (const format of formats) {
            const dManual = dayjs.utc(val, format, true);
            if (dManual.isValid()) {
              d = dManual;
              break;
            }
          }
        }
        if (d.isValid()) {
          this[f] = d.startOf('day').toDate();
        }
      }
    });
  }
}

export class CustomerClass {
  idCustomer: number | null = null;
  idUser: number | null = null;
  idCommercial: number | null = null;
  idCommercialOwner: number | null = null;
  Name: string = '';
  firstLastName: string = '';
  LastName: string = '';
  Email: string = '';
  confirmeEmail: string = '';
  Birthdate: Date | null = null;
  idSexTypes: number | null = null;
  Contact: string = '';
  // Photo: Image;
  PhotoPath: string = '';
  Photo: any;
  PhotoType: string = '';
  PhotoSize: string = '';
  NIF: string = '';
  NIB: string = '';
  IBAN: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;

  Newsletter: boolean = false;
  PrivacyPolicies: boolean = false;

  CCNumber: string = '';
  CCDateValidate: Date | null = null;
  CCLifelong: boolean = false;
  Drivinglicense: string = '';
  DrivinglicenseDate: Date | null = null;
  DrivinglicenseExpirationDate: Date | null = null;
  DriveLicenceCategory: string = '';
  idMaritalStatus: number | null = null;
  Profession: string = '';
  CAE: string = '';
  CAEDesignacao: string = '';
  idProfessionalsituation: number | null = null;
  idCommonNIFType: number | null = null;
  Obs: string = '';
  UUID: string = '';
  password: string = '';
  confirmepassword: string = '';
  idBillingAddressDefault: number | null = null;
  idShipToAddressDefault: number | null = null;
  AddressDetail: string = '';
  PostalCode: string = '';
  Region: string = '';
  Country: string = '';

  PlaceOfBirth: string = '';
  Nationality: string = '';
  Employer: string = '';
  customerShipToAddressClass: CustomerShipToAddressClass[] = [];
  customerFilesDriveLicenseClass: FilesClass[] = [];
  customerFilesCitizenCardClass: FilesClass[] = [];
  customerNIFAutorizationClass: CustomerNIFAutorizationClass[] = [];
  MyManager: string = '';
  MediatorServices: string = '';
  useMyManagersClass: UserMyManagersClass[] = [];
  AvailablePolicy: number = 0;
  isNIFEmpresa: boolean = false;
  UUIDLastChange: string = '';
  ConvitesEnviados: number = 0;
  Actived: boolean = false;
  AllPolicies: string = '';
  FoundIn: string = '';

  AutorizationCode: string = '';
  ContactRef: string = '';
  ResponsibleName: string = '';
  alertUser: Alert[] = [];
  alertClientAreaInsurances: Alert[] = [];
  alertClientAreaSafeSimulations: Alert[] = [];
  alertClientAreaInsurancesClaims: Alert[] = [];
  alertClientAreaCompaniesContacts: Alert[] = [];
  alertClientAreaCompaigns: Alert[] = [];
  customerFavoriteProposalsClass: CustomerFavoriteProposalsClass[] = [];
  AllowWhatsApp: boolean = false;
  NIFSearchDone: boolean = false; // ← nova flag
  DataSource: string = '';
  customerRedFlags: CustomerRedFlagClass[] = [];

  public parseDates() {
    if (this.NIB !== undefined && this.NIB !== null) {
      const cleanNib = String(this.NIB).replace(/^PT50/i, '').replace(/\D/g, '').trim();
      this.NIB = cleanNib;
    } else {
      this.NIB = '';
    }
    if (this.IBAN !== undefined && this.IBAN !== null) {
      const cleanIban = String(this.IBAN).trim();
      this.IBAN =
        !cleanIban || cleanIban.toLowerCase() === 'null' || cleanIban.toLowerCase() === 'undefined' ? '' : cleanIban;
    } else {
      this.IBAN = '';
    }

    const dateFields = [
      'Birthdate',
      'DateStart',
      'DateEnd',
      'CCDateValidate',
      'DrivinglicenseDate',
      'DrivinglicenseExpirationDate',
    ];
    dateFields.forEach(f => {
      if (this[f] && (typeof this[f] === 'string' || this[f] instanceof Date)) {
        const val = this[f];
        // 1. Tentar parse genérico (ISO 8601, etc) - mais comum em APIs
        let d = dayjs.utc(val);

        // 2. Se falhar e for string, tentar formatos comuns de input manual em Portugal
        if (!d.isValid() && typeof val === 'string') {
          const formats = ['DDMMYYYY', 'DD-MM-YYYY', 'DD-MM-YYYY'];
          for (const format of formats) {
            const dManual = dayjs.utc(val, format, true); // strict = true
            if (dManual.isValid()) {
              d = dManual;
              break;
            }
          }
        }

        if (d.isValid()) {
          // Usar UTC startOf('day') para garantir que a data é 00:00:00 UTC
          // Isso evita que fusos horários locais alterem o dia.
          this[f] = d.startOf('day').toDate();
        }
      } else if (this[f] && dayjs.isDayjs(this[f])) {
        // Se já for dayjs, garantir UTC e startOf day
        this[f] = (this[f] as any).utc().startOf('day').toDate();
      }
    });

    if (this.customerShipToAddressClass) {
      this.customerShipToAddressClass.forEach((x: any) => {
        if (x.parseDates) {
          x.parseDates();
        } else {
          // If it's just a plain object from API
          const temp = Object.assign(new CustomerShipToAddressClass(), x);
          if (temp.parseDates) temp.parseDates();
          Object.assign(x, temp);
        }
      });
    }
  }
}

export class CustomerApprovalRequestsClass {
  idCustomerApprovalRequests: number | null = null;
  idCustomer: number | null = null;
  idInsuranceClaimsQuizConfigPDF: number | null = null;
  idInsuranceClaimsQuizConfigStepper: number | null = null;
  idInsuranceClaimsQuizConfigStepperComponent: number | null = null;
  idInsuranceClaimsQuizConfigPDFComponentPosition: number | null = null;

  Email: string = '';
  EmailStatus: string = '';
  RequesterName: string = '';
  Document: any;
  DocumentConvertedText: any;
  Signature: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  AprovedDate: Date | null = null;
  ExpireDate: Date | null = null;
  URL: string = '';
  Code: string = '';
  UUID: string = '';
  UUIDLastChange: string = '';

  public parseDates() {
    const dateFields = ['DateStart', 'DateEnd', 'AprovedDate', 'ExpireDate'];
    dateFields.forEach(f => {
      if (this[f] && (typeof this[f] === 'string' || this[f] instanceof Date)) {
        const val = this[f];
        let d = dayjs.utc(val);
        if (!d.isValid() && typeof val === 'string') {
          const formats = ['DDMMYYYY', 'DD-MM-YYYY', 'DD-MM-YYYY'];
          for (const format of formats) {
            const dManual = dayjs.utc(val, format, true);
            if (dManual.isValid()) {
              d = dManual;
              break;
            }
          }
        }
        if (d.isValid()) {
          this[f] = d.startOf('day').toDate();
        }
      }
    });
  }
}

export class CustomerLayoutClass {
  idCommonLayoutClient: number | null = null;
  idCustomerLayout: number | null = null;
  idCustomer: number | null = null;
  Name: string = '';
  Description: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  Order: number | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class CustomerContactsDefault {
  idCustomerContactDefault: number | null = null;
  idCompanie: number | null = null;
  idCustomer: number | null = null;
}

export class CustomerContactsClass {
  idCustomerContacts: number | null = null;
  idCustomer: number | null = null;
  idCompanie: number | null = null;
  Contact1Label: string = '';
  Contact1Text: string = '';
  Contact2Label: string = '';
  Contact2Text: string = '';
  Contact3Label: string = '';
  Contact3Text: string = '';
  DateStart: Date | null = null;
  DateEnd?: Date | null = null;
  UUID: string = '';
  UUIDLastChange?: string = '';
}

export class CustomerShipToAddressClass {
  idShipToAddress: number | null = null;
  idCustomer: number | null = null;
  Description = '';
  StreetName = '';
  AddressDetail = '';
  PostalCode = '';
  Region = '';
  Country = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  Default: number | null = null;
  UUIDLastChange: string = '';

  public parseDates() {
    const dateFields = ['DateStart', 'DateEnd'];
    dateFields.forEach(f => {
      if (this[f] && (typeof this[f] === 'string' || this[f] instanceof Date)) {
        const val = this[f];
        let d = dayjs.utc(val);
        if (!d.isValid() && typeof val === 'string') {
          const formats = ['DDMMYYYY', 'DD-MM-YYYY', 'DD-MM-YYYY'];
          for (const format of formats) {
            const dManual = dayjs.utc(val, format, true);
            if (dManual.isValid()) {
              d = dManual;
              break;
            }
          }
        }
        if (d.isValid()) {
          this[f] = d.startOf('day').toDate();
        }
      }
    });
  }
}

export class CustomerNIB {
  idCustomerNIB: number | null = null;
  idCustomer: number | null = null;
  idBanks: number | null = null;
  BanksShortName: string = '';
  Name: string = '';
  ShortName: string = '';
  Description: string = '';
  BICSWIFT: string = '';
  IBAN: string = '';
  CodAF: string = '';
  Cod: string = '';
  CodAgencia: string = '';
  NIB: string = '';
  tooltip: string = '';
  Order: number | null = null;
  Country: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class CustomerInterests {
  idCustomerInterests: number | null = null;
  idCustomer: number | null = null;
  Checked: number | null = null;
  idInterests: number | null = null;
  AskJustification: boolean = false;
  Description: string = '';
  Justification: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  SuggestedInsurance: string = '';
  icon: string = '';
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class CustomerSendInvitationClass {
  idCustomerSendInvitation: number | null = null;
  idCustomer: number | null = null;
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class CustomerNIFAutorizationClass {
  idCustomerNIFPermission: number | null = null;
  idCustomer: number | null = null;
  Name: string = '';
  NamePrincipal: string = '';
  Description: string = '';
  NIFPrincipal: string = '';
  NIF: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  AutorizationDateRequest: Date | null = null;
  AutorizationURL: null = null;
  AutorizationDateAutorized: Date | null = null;
  Autorized: boolean = false;
  AutorizationCode: string = '';
  Order: number | null = null;
  Photo: any;
  PhotoPath: any;
  PhotoUrl: any = '';
  Actived?: any; // Novo campo para estado da conta
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class CustomerScheduleClass {
  idCustomerSchedule: number | null = null;
  idCustomer: number | null = null;
  Description: string = '';
  EveryDay: boolean = false;
  Monday: boolean = false;
  Tuesday: boolean = false;
  Wednesday: boolean = false;
  Thursday: boolean = false;
  Friday: boolean = false;
  Saturday: boolean = false;
  Sunday: boolean = false;
  StartTime: string = '';
  EndTime: string = '';
  Order: number | null = null;
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';
}

// Generated by https://quicktype.io

export class CustomerSubscribeDiscountsAdvantages {
  idSubscribeDiscountsAdvantages: number | null = null;
  Description: string = '';
  Email: string = '';
  Order: number | null = null;
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';
}

// Generated by https://quicktype.io

export class CustomerFavoriteProposalsClass {
  idCustomerFavoriteProposals: number | null = null;
  idCustomer: number | null = null;
  idProductsTypesProposals: number | null = null;
  Order: number | null = null;
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class CustomerCookiesAlertClass {
  idCustomerCookiesAlert: number | null = null;
  idCustomer: number | null = null;
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class CustomerCAEClass {
  idCustomerCAE: number | null = null;
  idCustomer: number | null = null;
  CAE: number | null = null;
  ATIVIDADE: string = '';
  Order: number | null = null;
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class CustomerEmail {
  idCustomerEmails: number | null = null;
  idCustomer: number | null = null;
  EmailLabel: string = '';
  EmailAddress: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class CustomerContactMethodsClass {
  idCustomerContactMethod: number | null = null;
  idCustomer: number | null = null;
  ContactLabel: string = '';
  ContactValue: string = '';
  DateStart: Date | null = null;
  DateEnd?: Date | null = null;
  UUID: string = '';
  UUIDLastChange?: string = '';
}

export class UserMyManagersClass {
  Name: string = '';
  Photo: Image | null = null;
  Info: string = '';
  codigo: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  Default: boolean = false;
  userMyManagersContactsClass: UserMyManagersContactsClass[] = [];
  userMyManagersEmailsClass: UserMyManagersContactsClass[] = [];
  // Indica se ocorreu um erro
  hasError: boolean = false;

  // Código de status HTTP do erro
  statusCode: number | null = null;

  // Texto do status HTTP (exemplo: "Not Found", "Unauthorized")
  statusText: string = '';

  // Mensagem amigável para o usuário
  userMessage: string = '';

  // Mensagem técnica para o desenvolvedor
  developerMessage: string = '';

  // Detalhes adicionais sobre o erro
  errorDetails: any = null;

  // URL onde o erro ocorreu (opcional, para rastreamento)
  errorUrl: string = '';
}

export class UserMyManagersContactsClass {
  TypeContact: string = '';
  Contact: string = '';
  // Indica se ocorreu um erro
  hasError: boolean = false;

  // Código de status HTTP do erro
  statusCode: number | null = null;

  // Texto do status HTTP (exemplo: "Not Found", "Unauthorized")
  statusText: string = '';

  // Mensagem amigável para o usuário
  userMessage: string = '';

  // Mensagem técnica para o desenvolvedor
  developerMessage: string = '';

  // Detalhes adicionais sobre o erro
  errorDetails: any = null;

  // URL onde o erro ocorreu (opcional, para rastreamento)
  errorUrl: string = '';
}
